// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"ea6e5b34","453":"542f59e6","712":"03f49adf"}[chunkId] + ".chunk.js";
};